import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { GetAction } from './GetAction'
import { buildMenuTree, isExternalUrl, menuHref, mergeMenuWithCmsPages } from '../utils/pageMenu'
import { mediaUrl } from '../utils/mediaUrl'
import { mockImg } from '../design/mockImg'
const DEFAULTS = {
  website_name: 'श्री अरिहंत दिगंबर जैन ट्रस्ट',
  footer_address: 'श्री अरिहंत दिगंबर जैन ट्रस्ट,\nचिंचवड, पुणे - 411019',
  footer_contact: '9876543210',
  logo_path: '',
}

function linksFromMenu(items) {
  const out = []
  buildMenuTree(items).forEach((item) => {
    const href = menuHref(item.url)
    const children = Array.isArray(item.children) ? item.children : []
    if (href && href !== '#') out.push(item)
    children.forEach((child) => {
      const childHref = menuHref(child.url)
      if (childHref && childHref !== '#') out.push(child)
    })
  })
  return out
}

function FooterMenuLink({ item }) {
  const href = menuHref(item.url)
  const className = 'hover:text-gold break-words'
  if (isExternalUrl(href) || Number(item.open_new_tab) === 1) {
    return (
      <a className={className} href={href} target="_blank" rel="noopener noreferrer">
        {item.label}
      </a>
    )
  }
  return (
    <Link className={className} to={href}>
      {item.label}
    </Link>
  )
}

function Footer() {
  const [settings, setSettings] = useState(DEFAULTS)
  const [footerLinks, setFooterLinks] = useState([])

  useEffect(() => {
    GetAction('get', {}, 'settings/get').then((data) => {
      if (data?.status === 'success' && data.response) {
        setSettings({
          website_name: (data.response.website_name || DEFAULTS.website_name).trim(),
          footer_address: data.response.footer_address || DEFAULTS.footer_address,
          footer_contact: data.response.footer_contact || DEFAULTS.footer_contact,
          logo_path: mediaUrl(data.response.logo_path) || '',
        })
      }
    })

    let cancelled = false
    ;(async () => {
      const [menuData, pagesData] = await Promise.all([
        GetAction('get', { location: 'footer' }, 'menu/list'),
        GetAction('get', { menu_location: 'footer' }, 'pages/pagesList'),
      ])
      if (cancelled) return
      const pages =
        pagesData?.status === 'success' && Array.isArray(pagesData.response)
          ? pagesData.response
          : []
      const menuItems =
        menuData?.status === 'success' && Array.isArray(menuData.response)
          ? menuData.response
          : []
      setFooterLinks(linksFromMenu(mergeMenuWithCmsPages(menuItems, pages)))
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const phone = String(settings.footer_contact || '').replace(/\s/g, '')
  const tel = phone.replace(/[^\d+]/g, '')

  return (
    <div className="site-design">
      <footer id="contact" className="relative overflow-hidden bg-maroon p-0 text-left font-normal text-white">
        <svg className="pointer-events-none absolute bottom-16 right-2 w-40 opacity-25 sm:w-56" viewBox="0 0 240 260" fill="none" stroke="#C59B27" strokeWidth="1.4" aria-hidden="true">
          <path d="M120 12l14 28h-28L120 12z" />
          <path d="M78 96 L120 40 L162 96" />
          <path d="M86 96h68v78H86z" />
          <path d="M108 174v-30h24v30" />
          <path d="M46 154l28-42 28 42" />
          <path d="M138 154l28-42 28 42" />
          <path d="M50 154h52v52H50z" />
          <path d="M138 154h52v52h-52z" />
          <path d="M24 214h192" />
          <path d="M32 214v16h176v-16" />
          <circle cx="120" cy="78" r="5" />
        </svg>
        <div className="relative mx-auto grid max-w-7xl gap-6 px-4 py-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <img src={settings.logo_path || mockImg('logo.jpg')} alt="" className="h-12 w-12 shrink-0 rounded-full border border-gold/70 bg-[#FFF8E8] object-cover" />
              <div>
                <p className="font-heading text-lg text-[#FFE7A3]">{settings.website_name}</p>
                <p className="text-xs text-gold">चिंचवड, पुणे</p>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-7 text-white/70">सेवा, संस्कार, जीवदया और समाज के लिए समर्पित एक सामाजिक एवं धार्मिक ट्रस्ट।</p>
          </div>
          <div>
            <h2 className="font-heading text-lg text-[#FFE7A3]">त्वरित लिंक</h2>
            <ul className="idx-quick-links mt-4 text-sm text-white/75">
              {footerLinks.map((item, idx) => (
                <li key={`${item.url || item.label}-${idx}`}>
                  <FooterMenuLink item={item} />
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="font-heading text-lg text-[#FFE7A3]">संपर्क जानकारी</h2>
            <ul className="mt-4 space-y-3 text-sm text-white/75">
              <li className="flex gap-2">
                <i className="fa-solid fa-location-dot mt-1 text-gold" aria-hidden="true" />
                <span style={{ whiteSpace: 'pre-line' }}>{settings.footer_address}</span>
              </li>
              <li className="flex gap-2">
                <i className="fa-solid fa-phone text-gold" aria-hidden="true" />
                {tel ? (
                  <a className="hover:text-gold" href={`tel:${tel}`}>{settings.footer_contact}</a>
                ) : (
                  <span>{settings.footer_contact}</span>
                )}
              </li>
              <li className="flex gap-2">
                <i className="fa-solid fa-envelope text-gold" aria-hidden="true" />
                <a className="hover:text-gold" href="mailto:office@arihant.org.in">office@arihant.org.in</a>
              </li>
            </ul>
          </div>
          <div>
            <h2 className="font-heading text-lg text-[#FFE7A3]">सोशल मीडिया</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a className="inline-flex items-center gap-2 text-white/75 hover:text-gold" href="https://www.instagram.com/shri_arihantdigambarjain_trust" target="_blank" rel="noopener noreferrer">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full border border-white/20"><i className="fa-brands fa-instagram" /></span>
                  Instagram
                </a>
              </li>
              <li>
                <a className="inline-flex items-center gap-2 text-white/75 hover:text-gold" href="https://www.youtube.com/@arihanttrust" target="_blank" rel="noopener noreferrer">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full border border-white/20"><i className="fa-brands fa-youtube" /></span>
                  YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="relative border-t border-white/10">
          <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 text-xs text-white/55 sm:flex-row sm:items-center sm:justify-between">
            <p>© {new Date().getFullYear()} {settings.website_name}. सर्वाधिकार सुरक्षित.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
